package app

import kotlinx.serialization.Serializable

@Serializable
data class Point(val x: Double, val y: Double)

@Serializable
enum class BlurShape {
    Rectangle,
    Circle,
    Freehand
}

enum class Tool {
    Rectangle,
    Circle,
    Freehand,
    Pan
}

@Serializable
data class BlurArea(
    val id: String,
    val x: Double,
    val y: Double,
    val width: Double,
    val height: Double,
    val shape: BlurShape,
    val blurRadius: Int,
    val path: List<Point> = emptyList()
)

data class ViewState(
    val zoom: Double = 1.0,
    val offsetX: Double = 0.0,
    val offsetY: Double = 0.0
)
